import { useContext } from 'react'
import { ThemeContext } from '@/lib/theme-context-definition'

export function useThemeContext() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useThemeContext must be used within ThemeProvider')
  }
  return context
}
